// extracted by mini-css-extract-plugin
export default {"header":"KtQenMl1u3nSXpiBR_dW","count":"zB7kOwfhNhy4WKLL3Gxg"};